import { DEFAULT_FORMAT_FALLBACK, FORMAT_PART_SEPARATOR, pluralCountLabels } from './constants';
import { FormatPluralCountOptions } from './types';
import { formatNumber, resolveNumberValue } from './formatNumber';

const getRussianPluralFormIndex = (value: number): number => {
  const absoluteValue = Math.abs(Math.trunc(value));
  const lastDigit = absoluteValue % 10;
  const lastTwoDigits = absoluteValue % 100;

  if (lastDigit === 1 && lastTwoDigits !== 11) return 0;

  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) return 1;

  return 2;
};

export const formatPluralCount = (options: FormatPluralCountOptions): string => {
  const {
    fallback = DEFAULT_FORMAT_FALLBACK,
    value,
    variant
  } = options;

  const numberValue = resolveNumberValue(value);

  if (numberValue === null) return fallback;

  const labels = pluralCountLabels[variant];
  const formattedValue = formatNumber({
    fallback,
    value: numberValue
  });

  return `${formattedValue}${FORMAT_PART_SEPARATOR}${labels[getRussianPluralFormIndex(numberValue)]}`;
};